import { useEffect, useState } from "react";
import { replaceUrl } from "@/lib/replaceUrl";

function currencyFromUrl(currencies: string[], fallback: string): string {
  if (typeof window === "undefined") return fallback;
  const param = new URLSearchParams(window.location.search).get("currency");
  return param && currencies.includes(param) ? param : fallback;
}

// The all-markets Inventory page's display currency, kept in the URL
// (?currency=USD) so a copied link shows the same figures. The fallback has
// no param. Replaces the history entry, like the tab param.
export function useCurrencyParam(currencies: string[], fallback: string): [string, (next: string) => void] {
  const [currency, setCurrency] = useState(() => currencyFromUrl(currencies, fallback));

  useEffect(() => {
    const url = new URL(window.location.href);
    if (currency === fallback) url.searchParams.delete("currency");
    else url.searchParams.set("currency", currency);
    replaceUrl(url);
  }, [currency, fallback]);

  return [currency, setCurrency];
}
